import { FilterTabEnum, JobItem } from 'domains/workspaceDomain';
import classNames from 'classnames';
import { UpOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import WorkspaceItemDetail from '../detail';

type Props = {
  jobData: JobItem;
  activeTab: FilterTabEnum | null;
  contentReadOnly?: boolean;
  onClose: () => void;
};
export const WorkspaceItemDetailWrapper = ({
  activeTab,
  jobData,
  contentReadOnly = false,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  return (
    activeTab && (
      <div className={classNames('workspace-item-detail-wrapper')}>
        <div
          className={classNames('workspace-item-tab-panel', {
            'workspace-item-tab-panel-readonly': contentReadOnly,
          })}
        >
          <WorkspaceItemDetail activeTab={activeTab} jobData={jobData} />
        </div>
        <div
          className="workspace-item-close"
          onClick={() => {
            const ele = document.querySelector(
              '.workspace-item-detail-wrapper'
            ) as HTMLElement;
            document.documentElement.scrollTop =
              document.documentElement.scrollTop - ele.offsetHeight - 24;

            onClose();
          }}
        >
          <UpOutlined />
          {t('workspace.list.close')}
        </div>
      </div>
    )
  );
};
